/* eslint-disable default-param-last */
import { API_ENDPOINT } from '../../constants';

import axiosInstance from '../../config/axios.config';
import { prepareErrorResponse, prepareSuccessReponse } from '../../utils/responseHandler';

export const getTaxRegions = async (limit = 10, page = 1, sortBy = 'count', sortOrder = 'DESC') => {
  const result = await axiosInstance.get(
    `${API_ENDPOINT.TAX_REGION}?sort_by=${sortBy}&sort_order=${sortOrder}&page=${page}&limit=${limit}`
  );
  if (result && result.ok) {
    return prepareSuccessReponse(result);
  }
  return prepareErrorResponse(result);
};

export const getComplianceRulesByRegion = async (taxRegionId) => {
  const endpoint = API_ENDPOINT.GET_TAX_REGION_RULES.replace(':id', taxRegionId);
  const result = await axiosInstance.get(endpoint);
  if (result && result.ok) {
    return prepareSuccessReponse(result);
  }
  return prepareErrorResponse(result);
};

export const createComplianceRule = async (taxRegionId, payload) => {
  const endpoint = API_ENDPOINT.GET_TAX_REGION_RULES.replace(':id', taxRegionId);
  const result = await axiosInstance.post(endpoint, payload);
  if (result && result.ok) {
    return prepareSuccessReponse(result);
  }
  return prepareErrorResponse(result);
};

export const updateComplianceRule = async (taxRegionId, ruleId, payload) => {
  const endpoint = API_ENDPOINT.GET_TAX_REGION_RULES.replace(':id', taxRegionId);
  const result = await axiosInstance.put(`${endpoint}/${ruleId}`, payload);
  if (result && result.ok) {
    return prepareSuccessReponse(result);
  }
  return prepareErrorResponse(result);
};

export const deleteComplianceRule = async (taxRegionId, ruleId) => {
  const endpoint = API_ENDPOINT.GET_TAX_REGION_RULES.replace(':id', taxRegionId);
  const result = await axiosInstance.delete(`${endpoint}/${ruleId}`);
  if (result && result.ok) {
    return prepareSuccessReponse(result);
  }
  return prepareErrorResponse(result);
};

export const getTaxRegionsStates = async () => {
  const result = await axiosInstance.get(API_ENDPOINT.TAX_REGION_STATES);
  if (result && result.ok) {
    return prepareSuccessReponse(result);
  }
  return prepareErrorResponse(result);
};
